/**
 * Auther: Joshua
 * date: 2018.12.25
 * for chinese report
 */

import PropTypes from 'prop-types';
import React from 'react';
import Tableau from '../Tableau'

const ChineseReport = ({params})=><Tableau storeIds={params.store_id} filter={(seq)=>seq.main !== 999 && seq.sub !== 999} langType = {'chinese'}/>
ChineseReport.propTypes = {
  params: PropTypes.object.isRequired
}
export default ChineseReport


/** WEBPACK FOOTER **
 ** ./client/pages/tableau/chinese/index.js
 **/